import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const notesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/notes",
  component: lazyRouteComponent(() => import("./notes.page.js"), "NotesPage"),
});
